import { inject, Injectable } from '@angular/core';
import { ERPCurrency } from '@/event-business/event-business.model';
import { Data2Service } from '@/common/data2.service';
import { InfoboxService } from '@/common/infobox/infobox.service';

export interface ExchangeRateResult {
	value: number;
	rate: number | null;
	date: string | null;
}

@Injectable({
	providedIn: 'root',
})
export class ExchangeRateService {
	private readonly api = inject(Data2Service);
	private readonly infobox = inject(InfoboxService);

	calculateCurrency(currency: string, currentRow: { value: unknown }): Promise<number> {
		switch (currency) {
			case ERPCurrency.EURO:
				return this.getExchangeRateDetails(currentRow).then((result) => result.value);
			default:
				return new Promise(null);
		}
	}

	getCurrencyExchangeRate(currentRow: { value: unknown }): Promise<number> {
		return this.getExchangeRateDetails(currentRow).then((result) => result.value);
	}

	getExchangeRateDetails(currentRow: { value: unknown }): Promise<ExchangeRateResult> {
		return new Promise((resolve, reject) => {
			this.api.get(
				`/currencyExchangeRate/${currentRow.value}`,
				(result: { data: ExchangeRateResult }, error: Error) => {
					if (error) {
						reject([]);
					} else {
						resolve(result.data);
					}
				},
			);
		});
	}
}
